export const submissionStatusOptions = [
  { label: "Solicitud creada", value: "CREATED" },
  { label: "Revisión de administrador", value: "REVIEW" },
  { label: "Revisión de implementadora", value: "REVISION" },
  { label: "Revisión de administrador 1", value: "REVIEW_1" },
  { label: "Revisión de implementadora 1", value: "REVISION_1" },
  { label: "Revisión de administrador 2", value: "REVIEW_2" },
  { label: "Revisión de implementadora 2", value: "REVISION_2" },
  { label: "Revisión de administrador 3", value: "REVIEW_3" },
  { label: "Revisión de implementadora 3", value: "REVISION_3" },
  { label: "Revisión de administrador final", value: "REVIEW_4" },
  { label: "Solicitud rechazada", value: "REJECTED" },
  { label: "Consejo local", value: "ON_LOCAL_COUNCIL" },
  { label: "En consejo directivo", value: "ON_COUNCIL" },
  { label: "En comité técnico", value: "ON_COMMITTEE" },
  { label: "En convenio", value: "ON_AGREEMENT" },
  { label: "Aprobada", value: "APPROVED" },
  { label: "Enviar a monitoreo", value: "AWAITING_INFO" },
  { label: "Listo para monitoreo", value: "INFO_SENT" },
  { label: "En monitoreo", value: "ON_MONITORING" },
  { label: "Liberación de monitoreo", value: "MONITORING_CONCLUDED" },
  { label: "Pagado", value: "PAID" },
  { label: "En Cierre", value: "IN_CLOSING"},
  { label: "Concluido", value: "ON_CLOSURE" }
]
